import { baseClasses } from '@weatherbug/common';
const { PulseBaseProvider } = baseClasses;

const getAllFavoriteLocationUri = '/api/favorite-locations/';
const createFavoriteLocationUri = '/api/favorite-locations/';
const updateFavoriteLocationUri = '/api/favorite-locations/{id}';
const deleteFavoriteLocationUri = '/api/favorite-locations/{id},{latitude},{longitude}';

const getAllFavoriteLocationsCacheKey = 'getAllFavoriteLocations';

const getAllFavoriteLocationsValidationFunction = (result) => {
    return result && Array.isArray(result);
};

const createFavoriteLocationValidationFunction = (result) => {
    return result?.Id && result?.Location?.Locality;
};

const deleteFavoriteLocationValidationFunction = () => {
    //Always return true because this returns no content
    return true;
};

const updateFavoriteLocationValidationFunction = (response) => {
    return (
        response?.Id &&
        response?.Position >= 0 &&
        typeof response?.Position === 'number' &&
        typeof response?.Location === 'object' &&
        response?.Location?.Id && response?.Location?.Locality
    );
};

export class FavoriteLocationsProvider extends PulseBaseProvider {
    constructor(authId, secret, options, logger) {
        super(authId, secret, options, logger);
        window.storage.sync[getAllFavoriteLocationsCacheKey] = this.getAllFavoriteLocationSyncer.bind(this);
    }

    async getAllFavoriteLocationSyncer(params) {
        const { id, syncParams, resolve, reject } = params;
        const queryParams = {};
        return await super.syncData(syncParams.key, id, queryParams, getAllFavoriteLocationUri, resolve, reject, getAllFavoriteLocationsValidationFunction, syncParams.pulseApi, null, null, false);
    }

    async getAllFavoriteLocations(refresh) {
        const syncParams = {
            refresh
        };
        const id = JSON.stringify(syncParams);

        if (refresh) {
            super.removeFromStorage(getAllFavoriteLocationsCacheKey, id);
        }

        return await super.loadFromStorage(getAllFavoriteLocationsCacheKey, id, syncParams);
    }

    async createFavoriteLocation(location) {
        const queryParams = {};

        return await super.postData(queryParams, location, createFavoriteLocationUri, true, createFavoriteLocationValidationFunction, false);
    }

    async updateFavoriteLocation(location) {
        const queryParams = {};

        const uri = updateFavoriteLocationUri.replace('{id}', location.Id);

        return await super.putData(queryParams, location, uri, true, updateFavoriteLocationValidationFunction, false);
    }

    async deleteFavoriteLocation(location) {
        const queryParams = {
            location
        };

        const uri = deleteFavoriteLocationUri
            .replace('{id}', location.Id)
            .replace('{latitude}', location.Locality.Latitude)
            .replace('{longitude}', location.Locality.Longitude);

        await super.delete(queryParams, null, uri, true, deleteFavoriteLocationValidationFunction, false);
        return location;
    }
}
